//----------------------------
// create changed skill entry
//----------------------------
export default function createChangedSkillEntry({
  name = '',
  action = '',
  id = null, // for character skill updates/deletes (character_skill id)
  payload = {},
} = {}) {
  // basic validation - name and action are required for valid change entry
  if (!name || !action) {
    throw new Error('Invalid input: name and action are required')
  }

  // extract payload fields with sensible defaults
  const {
    character = null, // for new character_skills (character id)
    skill = null, // for new character_skills (static skill id)
    ticks = 0,
    training = 0,
    favourite = false,
  } = payload || {}

  // resolve ids (explicit null if not provided)
  const resolvedSkillId = skill ?? null
  const resolvedCharacterId = character ?? null

  // build  output object progressively with clear intent for each action type
  const out = {
    name,
    action,
  }

  // for ADD and UPDATE we include a payload object describing ticks/training
  // for ADD we also include the static skill id and character id inside the payload
  if (action === 'ADD' || action === 'UPDATE') {
    const outPayload = {
      ticks,
      training,
      favourite,
    }

    if (action === 'ADD') {
      // when adding new character_skill - API expects skill & character inside payload
      outPayload.skill = resolvedSkillId
      outPayload.character = resolvedCharacterId
    }

    out.payload = outPayload
  }

  // include id for UPDATE and DELETE actions when provided
  // note: id is not included for ADD (it's provided inside payload for server-side creation).
  if (action !== 'ADD' && id != null) {
    out.id = id
  }

  return out
}
